import { ShowEventApi } from '../../generated/api';
import configuration from './configuration';

export default new ShowEventApi(configuration);
